var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 1.95703L6.43164 6.60352C6.2793 6.73047 6.12695 6.78125 6 6.78125C5.84766 6.78125 5.69531 6.73047 5.56836 6.62891L0.693359 1.95703C0.439453 1.72852 0.439453 1.32227 0.667969 1.09375C0.896484 0.839844 1.30273 0.839844 1.53125 1.06836L6 5.33398L10.4434 1.06836C10.6719 0.839844 11.0781 0.839844 11.3066 1.09375C11.5352 1.32227 11.5352 1.72852 11.2812 1.95703Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIcon);
export default __webpack_public_path__ + "static/media/chevron-icon.1e3774951e5a20047f69407f2aa30570.svg";
export { ForwardRef as ReactComponent };